module.exports = __webpack_public_path__ + "img/location-header_720.7b602237.jpg";